import React from 'react';
import './style.scss';
import MaximizedFrame from '../../frames/maximized';
import MinimizedFrame from '../../frames/minimized';
import PopupFrame from '../../base/popup';
import PreloaderWidget from './widget';
import PreloaderPopup from './popup';
import { TITLE } from '../chat';
import { VIEW_MODES } from '../../views/types';

class Preloader extends React.Component {
    render() {
        const { viewConfig } = this.props;

        const events = {
            ...this.props.events,
            close: () => {
                this.props.events.close('preloader');
            },
            minimize: null
        };

        switch (this.props.mode) {
            case VIEW_MODES.MINIMIZED:
                return <MinimizedFrame events={events} />;
            case VIEW_MODES.MAXIMIZED:
                return (
                    <MaximizedFrame
                        title={viewConfig.title ? viewConfig.title : TITLE}
                        events={events}
                    >
                        <PreloaderWidget message={viewConfig.message} icon={viewConfig.icon} />
                    </MaximizedFrame>
                );
            case VIEW_MODES.POPUP:
                return (
                    <PopupFrame events={events} theme="dark">
                        <PreloaderPopup config={viewConfig} events={events} />
                    </PopupFrame>
                );
            default:
                return null;
        }
    }
}

export default Preloader;
